<template>
    <div>
        <Loading v-bind:show="showLoadingExcluidos">
            <PageTitle title="Benefícios - Excluídos" />
            <Grid v-if="dadosAbaExcluidos && $featureToggle && $featureToggle.INTEGRA_BENEFICIO_EXCLUIDOS"
                  v-bind:Data="dadosAbaExcluidos.excluidos"
                  v-bind:Header="headerCancelados"
                  Name="ServicosCancelados"
                  Title="Cancelados"
                  OrderBy="periodoLetivo"
                  v-bind:HeaderDetalhes="headerCancelados"
                  v-bind:DetalhesCombo1="dadosAbaExcluidos.periodo"
                  v-bind:DetalhesCombo2="null"
                  v-bind:DetalhesCombo3="null" />
        </Loading>
    </div>
</template>
<script>
    import Grid from '@/components/Grid';
    import Beneficio from '@/services/BeneficioService.js';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';

    export default {
        name: 'BeneficioExcluido',
        components: {
            Grid,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                this.beneficioService = new Beneficio(this);

                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;
                    //Verifica se os dados da Aba ja esta carregado
                    if (a.BeneficioExcluido) {
                        this.dadosAba = a.Beneficios;
                    }
                    else {
                        this.showLoadingExcluidos = true;
                        this.dadosAba = this.excluidos();
                    }
                }
                else
                    this.$router.push('home');
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.BeneficioExcluido = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                aluno: null,
                showLoadingExcluidos: false,

                headerCancelados: [
                    {
                        Titulo: "Descrição",
                        Field: "descricaoCompleta",
                        Width: "200px",
                        Tipo: "texto"
                    },

                    {
                        Titulo: "Valor",
                        Field: "valorAplicacaoBeneficio",
                        Width: "80px",
                        Tipo: "moeda"
                    },

                    {
                        Titulo: "Data Início",
                        Field: "dataInicioVigencia",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Data Fim",
                        Field: "dataTerminoVigencia",
                        Width: "80px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Data Exclusão",
                        Field: "dataExclusao",
                        Width: "100px",
                        Tipo: "date"
                    }
                ],

                headerDetalheCancelados: [
                    {
                        Titulo: "Observação",
                        Field: "observacoes",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Usuário",
                        Field: "usuarioExclusao",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Tipo Lançamento",
                        Field: "tipoBolsa",
                        Tipo: "texto"
                    }
                ],


                dadosAba: null,
                dadosAbaExcluidos: null,
            }
        },
        methods: {
            excluidos() {
                if (this.$featureToggle.INTEGRA_BENEFICIO_EXCLUIDOS) {
                    this.showLoadingExcluidos = true;

                    this.beneficioService.GetBeneficiosExcluidos({
                        CodigoAluno: this.aluno.codigoAluno,
                        CodigoEspecialidade: this.aluno.codigoEspecialidade,
                        CodigoPeriodo: null,//this.aluno.codigoPeriodoSituacao,
                        CodigoEmpresa: this.aluno.codigoEmpresa
                    }).then(
                        data => {
                            if (data.ok) {
                                this.dadosAbaExcluidos = data.dados;
                            }
                            else {
                                this.$modal.alert(data.mensagem);
                            }
                        },
                        error => {
                            this.$modal.error('Ocorreu um erro ao tentar buscar os dados.', (error.body?.Mensagem || error?.response?.statusText || error.message));
                        }).finally(() => {
                            this.showLoadingExcluidos = false;
                        });
                }
                else {
                    this.$modal.alert(this.$msgFeatureToggle);
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }

    .md-tab {
        padding: 0;
        margin: 0 !important;
    }
</style>
